import type { EvaluatedSpecification, SimpleEvaluatedSpecification, SimpleMaterialQualityCategory } from 'api';

type EvaluatedSpecificationLike = EvaluatedSpecification | SimpleEvaluatedSpecification;

export type MaterialCategoryContext = Pick<SimpleMaterialQualityCategory, 'id' | 'name'> | null;

export const getMaterialCategoryFromEvaluatedSpecs = (
  evaluatedSpecs?: readonly EvaluatedSpecificationLike[]
): MaterialCategoryContext => {
  const specificationWithCategory = evaluatedSpecs?.find(
    (specification): specification is EvaluatedSpecification =>
      'category' in specification && specification.category !== null
  );

  if (!specificationWithCategory?.category) {
    return null;
  }

  return {
    id: specificationWithCategory.category.id,
    name: specificationWithCategory.category.name,
  };
};
